const fields = {
    IDS: 'ids',
};

export default fields;
